module.exports = __webpack_public_path__ + "static/media/img-dd06a814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/garnet-logo.png
// module id = 5285
// module chunks = 39